<template>
 <div class="matchPage">
    <div style="width:100%;">
        <!-- 顶部tabs -->
        <div style="width:100%; background:#fff; border-bottom:1px solid #dfdfdf; position: fixed; top: 0; z-index: 2;">
            <div class="header">
                <div class="left" style="cursor:pointer;" @click="clickLogoImg">
                    <img src="@/assets/img/logo.png" alt="">
                </div>
                <div class="right">
                    <div class="rightItem" :class="index==headerIndex?'activeHeader':''"  v-for="(item, index) in headerArr" :key="index" @click="clickHeaderItem(index)">{{item.name}}</div>
                </div>
            </div>
        </div>
        <!-- banner -->
        <div class="banner">
            <img src="@/assets/img/banner2.png" alt="">
        </div>
        <div class="phoneTestContent">
            <div class="title">
              登录验证
            </div>
            <el-form ref="phoneForm" :model="form" :rules="rules" label-width="70px"  label-position='right'>
                
                <el-row>
                  <el-col :span='20'>
                    <el-form-item label="" prop="mobile" class="formItem">
                      <img src="@/assets/img/submit/phoneIcon.png" alt="">
                      <el-input class="mobileInput"  v-model="form.mobile"  placeholder="请输入手机号码" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row >
                  <el-col :span='14'>
                    <el-form-item label="" prop="code"  class="formItem">
                      <img src="@/assets/img/submit/codeIcon.png" alt="">
                      <el-input class="codeInput"  v-model="form.code"  placeholder="请输入短信验证码" />
                    </el-form-item>
                  </el-col>
                  <el-col :span='6'>
                    <el-button :disabled="codeLoading" @click="getCode" type="primary" plain style=" margin-left: 36px;">
                      {{codeLoading?`验证码（${codeTime}s）`:'获取验证码'}}
                    </el-button>
                  </el-col>
                </el-row>
                <div style="width:100%;">
                  <el-button style="width:28%" :loading="submitLoading" type="primary" @click="submitPhone">确 &nbsp;&nbsp; 定</el-button>
                </div>
            </el-form>
          
        </div>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction } from '@/request/http'//引入封装的get post方法
import { VOUCHER, MOBILE, } from "@/store/mutation-types"
export default {
  name: 'phoneTest',
  components: {
  },
  data(){
    return{
        headerArr:[
           {name:'首页'},
           {name:'大赛奖项'},
           {name:'开发套件'},
           {name:'赛程安排'},
           {name:'参赛作品'},
           {name:'往期赛事'},
           {name:'提交作品'},
       ],
       headerIndex:'6',

       form: {},
       // 表单校验
       rules: {
        mobile: [{ required: true, pattern: /^1[0-9]{10}$/, message: "请输入正确的手机号码", trigger: "blur" }],
        code: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
       },
       codeLoading:false,
       codeTime:'60',
       timer1:null,
       submitLoading:false,
       url:{
          getCodeUrl:'/fetchSMSCode',//获取验证码
          checkCodeUrl:'/checkCode',//校验验证码
       },
    }
  },
    activated(){
    },
    mounted(){
      this.init()
    },
    methods:{
       //点击 顶部导航栏
        clickHeaderItem(i){
          this.headerIndex=i
          console.log('this.headerIndex==',this.headerIndex)
          if(this.headerIndex!='6'){
              this.$router.push({ path: '/', query: { indexFromSubmit: this.headerIndex}})
          }
        },
        //点击左上角logo
        clickLogoImg(){
          window.open('https://www.wch.cn')
        },


        init(){
          this.reset()
        },
        reset(){
          this.form = {};
          this.codeLoading = false
        },
        
        // 获取验证码
        getCode(){
          let reg = new RegExp(/^1[0-9]{10}$/)
          let flag = reg.test(this.form.mobile)
          if(this.form.mobile && flag){
            this.codeLoading = true
            var params = {
              mobile: this.form.mobile
            }
            postAction(this.url.getCodeUrl, params).then((res) => {
              console.log('res',res)
              if (res.data.code==200) {
                this.msgSuccess(res.data.msg);
                this.timer1=setInterval(() => {//定时器倒计时
                  if(this.codeTime>0){
                    this.codeTime -= 1
                    this.codeCountDown()
                  }
                }, 1000)
              } else {
                this.msgError(res.data.msg);
                window.clearInterval(this.timer1)//清除定时器 
                this.timer1=null
                this.codeTime=60
                this.codeLoading = false
              }
              
            });
          }else{
            this.msgWarning('请输入正确的手机号码')
          }
        },
        // 验证码倒计时
        codeCountDown(){
          if(this.codeTime==0){
            window.clearInterval(this.timer1)//清除定时器 
            this.timer1=null
            this.codeTime=60
            this.codeLoading = false
          }
        },

        submitPhone(){
          this.$refs.phoneForm.validate(valid => {
            if (valid) {
              this.submitLoading = true
              let params={...this.form}
              postAction(this.url.checkCodeUrl, params).then((res) => {
                if (res.data.code==200) {
                  localStorage.setItem('VOUCHER',res.data.msg)
                  localStorage.setItem('MOBILE',this.form.mobile)
                  console.log('存储的令牌和手机号：', localStorage.getItem('VOUCHER'), localStorage.getItem('MOBILE'))
                  this.$router.push({ path: '/submitWork', query:{sign:'1'}})
                  window.location.reload()
                } else {
                  this.msgError(res.data.msg);
                }
                this.submitLoading = false
              });
            }
          });
        },
        
    },
}
</script>

<style scoped > 

.matchPage{
    width: 1903px;
    /* width: 100%; */
}
/* header */
.header{
    width: 80%;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.header .left{
    font-size: 28px;
    font-weight: 600;
    line-height: 80px;
}
.header .right{
    display: flex;
}
.header .right .rightItem{
    font-size: 20px;
    line-height: 80px;
    margin: 0px 15px;
    width: 100px;
    text-align: center;
    color: #000;
    font-weight: 550;
    cursor: pointer;
}
.header .right .activeHeader{
    color: #008cff;
    border-bottom: 5px solid #008cff;
}
/* banner */
.banner{
    width: 100%;
    height: 416px;
    margin-top: 80px;
}
.banner img{
    width: 100%;
}
.phoneTestContent{
    width: 600px;
    margin: 0 auto;
    margin-top: 50px;
    background: #fff;
    /* padding: 30px; */
    padding: 30px 10px;
    border: 1px solid #ddd;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    border-radius: 8px;
}
.title{
  font-size: 20px;
  font-weight: 550;
  width: 20%;
  margin: 0 auto;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 2px solid #409eff;
}
.mobileInput /deep/.el-input__inner{
  padding: 0 38px;
}
.codeInput /deep/.el-input__inner{
  padding: 0 38px;
}
.formItem{
  position: relative;
}
.formItem img{
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
}
</style>
